import { ActionIcon, Tooltip } from '@mantine/core';
import { IconArchive, IconArchiveOff } from '@tabler/icons-react';

type Props = {
  isArchived: boolean;
  isLoading: boolean;
  onArchive: () => void;
  onRestore: () => void;
};

export const ArchiveToggle = ({ isArchived, isLoading, onArchive, onRestore }: Props) => {
  const label = isArchived ? 'Restore' : 'Archive';
  const Icon = isArchived ? IconArchiveOff : IconArchive;
  const onClick = isArchived ? onRestore : onArchive;
  const color = isArchived ? 'teal' : undefined;

  return (
    <Tooltip label={label} withArrow>
      <ActionIcon
        variant="subtle"
        radius="md"
        color={color}
        loading={isLoading}
        onClick={onClick}
        aria-label={label}
      >
        <Icon size={16} />
      </ActionIcon>
    </Tooltip>
  );
};
